import template from './bank-account-name-selector.html';

export default angular
  .module('app.holding.dashboard.bank-accounts')
  .directive('holdingBankAccountNameSelector', holdingBankAccountNameSelector)
  .name;

function holdingBankAccountNameSelector() {
  'ngInject';

  return {
    link,
    replace: true,
    require: 'ngModel',
    restrict: 'E',
    scope: {
      description: '@?',
      label: '@',
      options: '=',
    },
    template,
  };

  function getCodes(options) {
    if (!options) {
      return [];
    }
    return options.filter(option => !!option.selected).map(option => option.code);
  }

  function link(scope, _elem, _attrs, model) {
    scope.$watch('options', (val, oldVal) => {
      if (!val) {
        model.$setViewValue(null);
        return;
      }
      if (val.length === 1) {
        val[0].selected = true;
      }
      const codes = getCodes(val);
      const oldCodes = getCodes(oldVal);
      if (codes.length > 0) {
        model.$setViewValue(codes);
        model.$setTouched();
        model.$setDirty();
      } else {
        model.$setViewValue(null);
        if (codes.length === oldCodes.length) {
          model.$setPristine();
        } else {
          model.$setTouched();
          model.$setDirty();
        }
      }
    }, true);
  }
}



// WEBPACK FOOTER //
// ./src/holding/modules/app/modules/holding/modules/dashboard/modules/bank-accounts/directives/bank-account-name-selector/bank-account-name-selector.js